module.exports = __webpack_public_path__ + "img/chat-search.a3a6c32d.svg";